import VisaLogo from 'images/icons/visa-card.svg';
import MasterCardLogo from 'images/icons/mastercard.svg';
import DiscoverCardLogo from 'images/icons/discover-card.svg';
import AmexCardLogo from 'images/icons/amex-card.svg';
import DinersLogo from 'images/icons/diners.svg';
import JcbLogo from 'images/icons/jcb.svg';
import UnionPayLogo from 'images/icons/unionpay.svg';
import GenericCardLogo from 'images/icons/generic-card.svg';

import { CardBrands } from 'typescript/constants/enums/card';
import styles from 'typescript/apps/checkout_v3/components/payment/saved_cards/card_logo.module.scss';

const logosByBrand: Partial<{ [_key in CardBrands]: string }> = Object.freeze({
  [CardBrands.VISA]: VisaLogo,
  [CardBrands.MASTERCARD]: MasterCardLogo,
  [CardBrands.DISCOVER]: DiscoverCardLogo,
  [CardBrands.AMEX]: AmexCardLogo,
  [CardBrands.DISCOVER_DINERS]: DinersLogo,
  [CardBrands.JCB]: JcbLogo,
  [CardBrands.UNION_PAY]: UnionPayLogo,
});

const getLogoByBrand = (brand: string): string => {
  return logosByBrand[brand] || GenericCardLogo;
};

interface CardLogoProps {
  brand: string;
}

const CardLogo = ({ brand }: CardLogoProps) => {
  return (
    <img className={styles.cardLogo} src={getLogoByBrand(brand)} alt={brand} />
  );
};

export default CardLogo;
